import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-xl mb-3" }, "Send A Message", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3" }, "Send out a bulk SMS message to your campaign contacts.", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 font-italic m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}
const _hoisted_5 = {
  key: 1,
  class: "text-red-500 font-italic m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}
const _hoisted_6 = {
  key: 2,
  class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}
const _hoisted_7 = { class: "font-bold text-cyan-800" }
const _hoisted_8 = { class: "surface-card p-4 shadow-2 border-round" }
const _hoisted_9 = { class: "grid formgrid p-fluid" }
const _hoisted_10 = { class: "field mb-4 col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "font-medium"
}, "Message Editor", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, null, -1)
const _hoisted_13 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading || _ctx.currentCampaignLoading || _ctx.phoneNumbersLoading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_TabMenu, {
      activeIndex: _ctx.active,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      model: _ctx.tabItems,
      class: "mb-4"
    }, {
      item: _withCtx(({ item, props }) => [
        _createVNode(_component_router_link, {
          to: { name: item.route },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate }) => [
            _withDirectives((_openBlock(), _createElementBlock("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), [
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.icon)), null, 16),
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(item.label), 17)
            ], 16, _hoisted_1)), [
              [_directive_ripple]
            ])
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      _: 1
    }, 8, ["activeIndex", "model"]),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"78vh"} }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        (!_ctx.currentCampaign?.phoneNumberId)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Messaging is disabled. You do not currently have a phone number associated with this campaign."))
          : (_ctx.campaignPhoneNumber && !_ctx.campaignPhoneNumber.isActive)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Messaging is disabled. The phone number associated with this campaign (" + _toDisplayString(_ctx.campaignPhoneNumber.phoneNumber) + ") is no longer active on your connected Twilio account. Please associate an active phone number with this campaign. ", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode(" Note: Please remember that you are sending messages from this phone number: "),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.campaignPhoneNumber?.phoneNumber), 1)
              ])),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Editor, {
                onTextChange: _ctx.parseText,
                editorStyle: "height: 320px",
                readonly: !_ctx.canSend
              }, {
                toolbar: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["onTextChange", "readonly"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  onClick: _ctx.sendBulkSMS,
                  label: "Send Message",
                  class: "w-auto mt-3",
                  icon: "pi pi-send",
                  disabled: !_ctx.canSend
                }, null, 8, ["onClick", "disabled"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}